// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e60f9841","278":"9f590869","614":"28743e7e","734":"2f354bdd"}[chunkId] + ".chunk.js";
};